import { forwardRef, useCallback } from 'react';
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import Color from 'color';

import { Alert, AlertTitle, Typography } from '@mui/material';

interface ErrorWithDetailsProps extends CustomContentProps {
  details?: string;
}

export const ErrorWithDetailsSnackbar = forwardRef<HTMLDivElement, ErrorWithDetailsProps>(
  ({ id, message, details, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const errorRed = Color('#f04438');

    return (
      <SnackbarContent
        ref={ref}
        sx={{
          '@media (min-width:600px)': {
            minWidth: '344px !important',
          },
        }}
      >
        <Alert
          variant="filled"
          severity="error"
          onClose={handleDismiss}
          sx={{
            backgroundColor: errorRed.toString(),
            color: 'white',
          }}
        >
          <AlertTitle sx={{ color: 'white', mb: details ? 1 : 0 }}>
            <Typography variant="body1" fontWeight={600}>
              {message}
            </Typography>
          </AlertTitle>

          {details && (
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              {details}
            </Typography>
          )}
        </Alert>
      </SnackbarContent>
    );
  },
);

ErrorWithDetailsSnackbar.displayName = 'ErrorWithDetailsSnackbar';

export default ErrorWithDetailsSnackbar;
